import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-15e1ae3a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "project-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "dis-space-4 me-max-title"
}, "与2000+家实体企业携手共进", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "info dis-space-2 me-main-title"
}, "持续助力客户成功", -1));
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = {
  class: "custom-slick-arrow",
  style: {
    "left": "10px",
    "z-index": "1"
  }
};
const _hoisted_6 = {
  class: "custom-slick-arrow",
  style: {
    "right": "10px"
  }
};
const _hoisted_7 = {
  class: "press-card"
};
const _hoisted_8 = {
  class: "item-img-box"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "item-info-box dis-space-2"
};
const _hoisted_11 = {
  class: "item-content me-content-lt"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "了解更多", -1));
const _hoisted_14 = [_hoisted_13];
const _hoisted_15 = {
  class: "press-card"
};
const _hoisted_16 = {
  class: "item-img-box"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  class: "item-info-box dis-space-2"
};
const _hoisted_19 = {
  class: "me-content-vl"
};
const _hoisted_20 = {
  class: "item-content me-content"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "了解更多", -1));
const _hoisted_23 = [_hoisted_22];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = _resolveComponent("a-button");
  const _component_left_circle_outlined = _resolveComponent("left-circle-outlined");
  const _component_right_circle_outlined = _resolveComponent("right-circle-outlined");
  const _component_a_carousel = _resolveComponent("a-carousel");
  const _component_detailModal = _resolveComponent("detailModal");
  const _component_ConsultModal = _resolveComponent("ConsultModal");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "banner-box",
    style: _normalizeStyle({
      height: _ctx.bannerHeight
    })
  }, [_createElementVNode("div", {
    class: "banner-info",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_hoisted_2, _hoisted_3, _createVNode(_component_a_button, {
    class: "service dis-space-2 me-content",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.openConsultModdal())
  }, {
    default: _withCtx(() => [_createTextVNode("项目咨询")]),
    _: 1
  })], 4)], 4), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: _normalizeClass(["custom-project", {
      'custom-project-entry': _ctx.customProjectState.showTime
    }]),
    id: "custom-project"
  }, [_createVNode(_component_a_carousel, {
    arrows: "",
    class: "carousel-content",
    dotsClass: "dots-panel"
  }, {
    prevArrow: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_left_circle_outlined)])]),
    nextArrow: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_right_circle_outlined)])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectListOne, (item, index) => {
      return _openBlock(), _createElementBlock("label", {
        class: "card-item",
        key: index
      }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
        src: item.img
      }, null, 8, _hoisted_9)]), _createElementVNode("span", _hoisted_10, [_createElementVNode("label", null, _toDisplayString(item.title), 1), _createElementVNode("label", _hoisted_11, _toDisplayString(item.content), 1), _createElementVNode("label", {
        onClick: $event => _ctx.openDetailHandle(item)
      }, _hoisted_14, 8, _hoisted_12)])]);
    }), 128))]), _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectListTwo, (item, index) => {
      return _openBlock(), _createElementBlock("label", {
        class: "card-item",
        key: index
      }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("img", {
        src: item.img
      }, null, 8, _hoisted_17)]), _createElementVNode("span", _hoisted_18, [_createElementVNode("label", _hoisted_19, _toDisplayString(item.title), 1), _createElementVNode("label", _hoisted_20, _toDisplayString(item.content), 1), _createElementVNode("label", {
        onClick: $event => _ctx.openDetailHandle(item)
      }, _hoisted_23, 8, _hoisted_21)])]);
    }), 128))])]),
    _: 1
  })], 2), _createVNode(_component_detailModal, {
    ref: "detailModalRef"
  }, null, 512), _createVNode(_component_ConsultModal, {
    ref: "consultModalRef"
  }, null, 512)])]);
}